import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { TextareaModule } from 'primeng/textarea';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { ToastModule } from 'primeng/toast';
import { AtividadeManobrasService } from './atividade-manobras.component.service';

import { Manobras } from '../models/manobras';
import { UserService } from '@/core/service/user.service';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'max-atividade-manobras',
    templateUrl: './atividade-manobras.component.html',
    styleUrls: [],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        TableModule,
        TextareaModule,
        ButtonModule,
        DialogModule,
        SelectModule,
        ToastModule
    ],
    providers: [MessageService]
})
export class AtividadeManobrasComponent implements OnInit {
  atividadeManobras: Manobras[] = [];
  @Input() idAtividade: number = 0;
  loading: boolean = false;
  value: string = '';
  visible: boolean = false;
  optionsManobra: any;
  valueManobra: any;
  idRegistroMovimentacao: number = 0;
  idUser: number = 0;

  constructor(
    private atividadeManobrasService: AtividadeManobrasService,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.idUser = this.userService.getUserId();
    this.loading = true;
    this.getAtividadeManobras();
    this.mockManobra();
  }

  getAtividadeManobras() {
    this.atividadeManobrasService.getAtividadeManobras(this.idAtividade).subscribe((atvmanobras) => {
      this.atividadeManobras = atvmanobras;
      this.loading = false;
    });
  }

  showDialog(value: any) {
    this.idRegistroMovimentacao = value.idRegistroMovimentacao;
    this.visible = true;
    this.valueManobra = this.optionsManobra.find((option: any) => option.name === value.tratamento);
  }

  mockManobra() {
    this.optionsManobra = [
      { name: 'Pendente', code: 'Pendente' },
      { name: 'Tratado', code: 'Tratado' },
    ];
  }

  updManobras() {
    const body = {
      idRegistroMovimentacao: this.idRegistroMovimentacao,
      idUsuario: Number(this.idUser),
      tratamento: this.valueManobra.name,
    };

    this.atividadeManobrasService.updManobras(body).subscribe({
      next: (response) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Tratamento da Manobra atualizada com sucesso!',
        });

        setTimeout(() => {
          this.getAtividadeManobras();
        }, 1000);
        this.visible = false;
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Ocorreu um erro ao atualizar o Tratamento da Manobra.',
        });

        // Erro na requisição
        this.visible = false;
      },
    });
  }
}
